import {  Typography } from "@mui/material";
import AutoHelp from "../../../../UI/Wrappers/AutoHelp";

const Username = ({ fontSize, user }) => {
  return (
    <AutoHelp {...{ fixedTooltip: user }}>
      <Typography noWrap {...{ fontSize, sx: { cursor: "default" } }}>
        {user}
      </Typography>
    </AutoHelp>
  );
};

export default Username;
